<template>
  <div class="lad-ask-question">
    <el-header class="lad-ask-question--header" align="center">
      <h2>{{ success ? $t(`${base}.success.title`) : $t(`${base}.title`) }}</h2>
    </el-header>
  </div>
</template>

<script>
export default {
  name: 'LadAvailabilityHeader',
  props: {
    success: { type: Boolean, default: false },
  },
  data() {
    return {
      base: 'components.ask_question',
    }
  },
}
</script>

<style lang="scss">
.lad-ask-question {
  &--header {
    padding-right: 0;
    padding-left: 0;
    height: auto !important;

    h2 {
      font-size: 30px;
    }

    span {
      text-transform: uppercase;
      font-size: 16px;
    }
  }
}
</style>
